export interface IAdvantagesData {
  img: string;
  title: string;
  subtitle: string;
}

export const AdvantagesData = [
  {
    img: '/advantages/chart.svg',
    title: 'Новая и перспективная ниша',
    subtitle: 'Аудитория пользователей активно растет на 10-20% ежемесячно.'
  },
  {
    img: '/advantages/launch.svg',
    title: 'Быстрый запуск',
    subtitle:
      'Поставка оборудования меньше месяца, а обучение занимает всего 2 недели.'
  },
  {
    img: '/advantages/powerbank.svg',
    title: 'Простое управление',
    subtitle:
      'Ключевая задача установить станцию в проходном месте и оказывать поддержку. 1 человек может обслуживать до 100 терминалов.'
  },
  {
    img: '/advantages/laptop.svg',
    title: 'Пассивный доход',
    subtitle:
      'Активная фаза (установка терминалов) длится от 1 до 3 недель, контроль и аналитика осуществляются дистанционно через онлайн приложение.'
  },
  {
    img: '/advantages/wallet.svg',
    title: 'Отсутствие расходов',
    subtitle:
      'Все терминалы EnerGO установлены без арендной платы, в отличии от вендинговых аппаратов.'
  },
  {
    img: '/advantages/franchise.svg',
    title: 'Мастер-франшиза',
    subtitle:
      'Возможность приобрести мастер-франшизу. Управляй городом, регионом или страной!'
  }
];
